import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-test-out-fail-modal',
  standalone:false,
  templateUrl: './test-out-fail-modal.component.html',
  styleUrl: './test-out-fail-modal.component.scss'
})
export class TestOutFailModalComponent {

  constructor(private dialogRef: MatDialogRef<TestOutFailModalComponent>) {}
  close() {
    // Logic to close the modal
      this.dialogRef.close();
  }

  continue() {
    // Logic to navigate to the Instructor-Led Training (ILT) session enrollment page
    this.dialogRef.close('continue')
  }

}
